"use client";

import LandingPageLayout from "@/components/layout/LandingPageLayout";
import Link from "next/link";

const Terms = () => {
  return (
    <LandingPageLayout>
      <section className="flex flex-col items-center lg:p-20 lg:pb-0 md:pb-0 pb-0 p-6 md:p-12 text-sm">
        <p className="text-sm">Legal</p>
        <h2 className="text-primary font-semibold text-2xl md:text-3xl">
          Terms of Use
        </h2>
        <p className="text-xs">Last Updated: November 1st, 2024</p>
        <div className="w-full mt-8 space-y-6">
          <p>
            These Terms of Use (these &quot;Terms&quot;), together with any
            documents expressly incorporated by reference in these Terms,
            represent an agreement between you and Monietab
            (&quot;Monietab&quot;) and contain the terms and conditions
            governing your use of and access to our website at{" "}
            <Link href="https://monietab.com">https://monietab.com</Link> and
            all affiliated websites and mobile applications owned and operated
            by us (collectively, the &quot;Website&quot;) and our products,
            services, and applications (together with the Website, the
            &quot;Services&quot;) including any content or functionality offered
            through the Website or the Services, whether as a guest or
            registered user.
          </p>
          <p>
            &quot;You&quot; and &quot;your&quot; mean the person who uses or
            accesses the Services.
          </p>
          <p>
            &quot;We,&quot; &quot;us,&quot; and &quot;our&quot; mean Monietab
            and its successors, affiliates, and assignees.
          </p>
          <p>
            As used in these Terms, &quot;Monietab Account&quot; means the
            account you have with us for the Services.
          </p>
          <p>
            Your use of and access to the Services are subject at all times to
            these Terms and our Privacy Policy. Please read these Terms and our
            Privacy Policy carefully. By using or accessing the Services, you
            represent that you have read and understand these Terms and our
            Privacy Policy and you agree to be bound by these Terms and our
            Privacy Policy. If you do not agree to all the terms and conditions
            of these Terms and our Privacy Policy, do not use or access the
            Services
          </p>
          <h1 className="font-semibold text-base">
            1. Eligibility and Account Creation
          </h1>
          To use the Services, you must: a) Accept and agree to these Terms and
          our Privacy Policy; b) Register with us on the Website; c) Be a
          Nigerian citizen (or a legal Nigerian resident) of at least eighteen
          (18) years of age; d) Have a Bank Account with a Nigerian financial
          institution; and e) Provide all information requested by us, such as
          your name, email address, phone number, online credentials for your
          Bank Account, and such other information as we may request from time
          to time (collectively, &quot;User Information&quot;). You represent
          and warrant that all User Information you provide us from time to time
          is true, accurate, current, and complete. You agree to promptly notify
          us of changes to your User Information by updating your Monietab
          Account on the Website; provided, however, that you must notify us at
          least three Business Days before any changes to your Bank Account
          information, including, but not limited to, the closure of your Bank
          Account for any reason by calling 08143859120 or emailing
          hello@monietab.com or by updating your Monietab Account via the
          Website. For our compliance purposes and in order to provide the
          Services to you, you hereby authorize us to, directly or through a
          third party, obtain, verify, and record information and documentation
          that helps us verify your identity and Bank Account information. When
          you register for the Services and from time to time thereafter, we may
          require you to provide and/or confirm information and documentation
          that will allow us to identify you, such as: a) A copy of your
          government-issued photo ID, such as a passport, national identity card
          or driver&apos;s license; b) Bank Verification Number (BVN); c) A copy
          of a utility bill, bank statement, affidavit, or other bill, dated
          within three months of our request, with your name and Nigerian street
          address on it; and d) Such other information and documentation that we
          may require from time to time.
          <h1 className="font-semibold text-base">2. Services Description</h1>
          The purpose of the Services is to help you save, invest, and earn
          rewards with minimal effort. Our core features include: a) Savings:
          Various savings products with different interest rates ranging from 8%
          to 25%, including halal options for Muslim users who don&apos;t want
          interest on their savings. b) Tabcoin: A points system that users can
          earn through saving, taking financial lessons, or staking to play
          games. c) Rewards and Prizes: Users can redeem prizes using their
          accumulated Tabcoin. d) Gamification Elements: Daily streaks for
          taking financial lessons, leaderboards, and badges.
          <h1 className="font-semibold text-base">3. Transactions and Fees</h1>
          You can transfer funds to your Monietab Account from any available
          options on the Website. You can request your savings at any time or on
          any of our payout days, depending on the specific product under the
          Services. Your savings and funds transfer activities via the Website
          shall be subject to transaction and balance limits in accordance with
          applicable law. Fees and charges may apply when you transfer from your
          wallet to your bank or when you withdraw your savings before maturity.
          You may lose your savings interest when you withdraw your saving
          before maturity. Interest is calculated daily and distributed monthly.
          We reserve the right to charge fees for the Services in the future, at
          our sole discretion. We will notify you before charging a fee for the
          Services by delivering notice to you electronically, by posting such
          fee on the Website, or by any other method permitted by applicable
          law. If you continue using the Services after such notice, you must
          pay all applicable fees for the Services.
          <h1 className="font-semibold text-base">4. Tabcoin and Rewards</h1>
          You can earn Tabcoin by saving, taking financial lessons, or staking
          to play games. Tabcoin can be used to redeem prizes in the reward
          center. There are no conditions for rewards other than having
          sufficient Tabcoin to exchange for the desired prize.
          <h1 className="font-semibold text-base">5. User Conduct</h1>
          You agree to use the Services only for lawful purposes and in
          accordance with these Terms. You agree not to use the Services: a) In
          any way that violates any applicable federal, state, local, or
          international law or regulation. b) To transmit, or procure the
          sending of, any advertising or promotional material, including any
          &quot;junk mail,&quot; &quot;chain letter,&quot; &quot;spam,&quot; or
          any other similar solicitation. c) To impersonate or attempt to
          impersonate Monietab, a Monietab employee, another user, or any other
          person or entity. d) To engage in any other conduct that restricts or
          inhibits anyone&apos;s use or enjoyment of the services, or which, as
          determined by us, may harm Monietab or users of the services or expose
          them to liability.
          <h1 className="font-semibold text-base">
            6. Intellectual Property Rights
          </h1>
          The Services and its entire contents, features, and functionality
          (including but not limited to all information, software, text,
          displays, images, video, and audio, and the design, selection, and
          arrangement thereof) are owned by Monietab, its licensors, or other
          providers of such material and are protected by Nigerian and
          international copyright, trademark, patent, trade secret, and other
          intellectual property or proprietary rights laws.
          <h1 className="font-semibold text-base">
            7. Privacy and Data Protection
          </h1>
          Your privacy is important to us. Our Privacy Policy, which is
          incorporated into these Terms, explains how we collect, use, and
          protect your personal information. By using the Services, you consent
          to the collection, use, storage, and disclosure of your information as
          set forth in these Terms and our Privacy Policy. You agree that we
          have the right to share your personal information and any other
          information relating to you, your transactions and/or your Monietab
          Account: a) With any of our affiliated companies and service
          providers; b) With financial service providers and non-financial
          companies, such as email service providers that perform marketing
          services on our behalf, and fraud prevention service providers that
          use the information to provide services to us; c) With a
          non-affiliated third-party to access and transmit your personal and
          financial information from a relevant financial institution. You grant
          the third-party the right, power, and authority to access and transmit
          this information according to terms of their privacy policy; d) With
          selected third parties including business partners for the performance
          of any contract we enter into with them or you and/or to complete a
          transaction with you; e) With third parties to whom we may choose to
          sell, transfer or merge parts of our business or our assets; f) In
          compliance with applicable law, legal processes, regulatory guidelines
          and regulatory directives that require us to report or disclose
          information to a governmental body, regulatory authority or any other
          competent authority; g) With relevant law enforcement officials or
          other third parties, such as investigators or auditors, if we believe
          it is appropriate to investigate fraud.
          <h1 className="font-semibold text-base">
            8. Communications and Electronic
          </h1>
          Signatures To the extent permitted by applicable law, you consent to
          use electronic signatures and to electronically receive all records,
          notices, statements, communications, and other items for all services
          provided to you under these Terms and in connection with your
          relationship with us (collectively, &quot;Communications&quot;) that
          we may otherwise be required to send or provide you in paper form
          (e.g., by mail). You may withdraw your consent to receive
          Communications electronically at any time by contacting us at
          hello@monietab.com. If you withdraw your consent to receive
          Communications electronically, we will close your Monietab Account and
          return the balance in your Monietab Account to your Bank Account as
          set forth in these Terms, and you will no longer be able to use your
          Monietab Account or the Services, except as expressly provided in
          these Terms.
          <h1 className="font-semibold text-base">9. Termination</h1>
          We may terminate or suspend your account and bar access to the
          Services immediately, without prior notice or liability, under our
          sole discretion, for any reason whatsoever and without limitation,
          including but not limited to a breach of the Terms. Upon termination,
          your right to use the Services will immediately cease. If you wish to
          terminate your account, you may simply discontinue using the Services
          or contact us at hello@monietab.com. All provisions of the Terms which
          by their nature should survive termination shall survive termination,
          including, without limitation, ownership provisions, warranty
          disclaimers, indemnity and limitations of liability.
          <h1 className="font-semibold text-base">
            10. Limitation of Liability
          </h1>
          To the maximum extent permitted by applicable law, in no event shall
          Monietab, its affiliates, directors, employees, agents, partners,
          suppliers, or content providers be liable for any indirect, punitive,
          incidental, special, consequential, or exemplary damages, including
          without limitation damages for loss of profits, goodwill, use, data,
          or other intangible losses, resulting from: a) Your use of, or
          inability to use, the Services; b) Any unauthorized access to or use
          of our servers and/or any personal information stored therein; c) Any
          interruption or cessation of transmission to or from the Services; d)
          Any bugs, viruses, trojan horses, or the like, which may be
          transmitted to or through the Services by any third party; e) Any
          errors or omissions in any content or for any loss or damage incurred
          as a result of the use of any content posted, emailed, transmitted, or
          otherwise made available through the Services.
          <h1 className="font-semibold text-base">11. Disclaimer</h1>
          Your use of the Services is at your sole risk. The Services are
          provided on an &quot;AS IS&quot; and &quot;AS AVAILABLE&quot; basis.
          The Services are provided without warranties of any kind, whether
          express or implied, including, but not limited to, implied warranties
          of merchantability, fitness for a particular purpose,
          non-infringement, or course of performance. Monietab, its
          subsidiaries, affiliates, and licensors do not warrant that: a) The
          Services will function uninterrupted, secure, or available at any
          particular time or location; b) Any errors or defects will be
          corrected; c) The Services are free of viruses or other harmful
          components; d) The results of using the Services will meet your
          requirements.
          <h1 className="font-semibold text-base">12. Governing Law</h1>
          These Terms shall be governed and construed in accordance with the
          laws of Ondo State, Nigeria, without regard to its conflict of law
          provisions.
          <h1 className="font-semibold text-base">13. Dispute Resolution</h1>
          Any disputes arising out of or related to these Terms or the Services
          shall be resolved through binding arbitration in accordance with the
          Arbitration and Conciliation Act of Nigeria. The arbitration shall
          take place in Akure, Ondo State, Nigeria, and shall be conducted in
          the English language.
          <h1 className="font-semibold text-base">14. Changes to Terms</h1>
          We reserve the right, at our sole discretion, to modify or replace
          these Terms at any time. We will provide notice of any material
          changes by posting the updated Terms on the Website or by sending you
          an email. Your continued use of the Services after any such changes
          constitutes your acceptance of the new Terms.
          <h1 className="font-semibold text-base">15. Indemnification</h1>
          You agree to defend, indemnify, and hold harmless Monietab, its
          affiliates, licensors, and service providers, and its and their
          respective officers, directors, employees, contractors, agents,
          licensors, suppliers, successors, and assigns from and against any
          claims, liabilities, damages, judgments, awards, losses, costs,
          expenses, or fees (including reasonable attorneys&apos; fees) arising
          out of or relating to your violation of these Terms or your use of the
          Services, including, but not limited to, your User Content, any use of
          the Services&apos; content, services, and products other than as
          expressly authorized in these Terms, or your use of any information
          obtained from the Services.
          <h1 className="font-semibold text-base">
            16. Anti-Money Laundering Compliance
          </h1>
          You represent and warrant that, to the best of your knowledge, none of
          the funds used on the Monietab platform are derived from or related to
          any activity that is deemed to be in contravention or breach of
          applicable law, particularly in relation to anti-money laundering
          regulations. We reserve the right to perform due diligence checks on
          all users of the Website. You agree to provide all such information
          and documentation as we may require for these purposes.
          <h1 className="font-semibold text-base">17. Contact Us</h1>
          If you have any questions about these Terms, please contact us at:
          Mora Technologies Limited, Plot 4, 5 Adeloye Oladejo street,
          Alagbaka, Akure 340001, Ondo State, Nigeria. Email: hello@monietab.com
          Phone: 08143859120 By using the Services, you acknowledge that you
          have read and understood these Terms and agree to be bound by them.
        </div>
      </section>
    </LandingPageLayout>
  );
};

export default Terms;
